import { useState } from "react";
import { createModel } from "hox";
import { customerService } from "./customerService";
import { message } from "antd"
import { convertRes2Blob } from "@/erp_subpackage/utils/exportFile";
import useGlobalModel, { transPgToPagination, defaultMdCmParam } from "@/erp_subpackage/model/globalModel";
import { useDictModel } from "../dict/dictModel";
import { useLockFn } from "ahooks";
import { getUserInfo } from "@/utils/dataStorage"
import { supplierService } from "../supplier/supplierService";

export const useCustomerModel = createModel(function () {
    const { sourceApp, branch } = defaultMdCmParam
    const { user: { shopId, shopCode, shopName, organType, orgCode, orgName } } = useGlobalModel()
    const { getTreeNodeName } = useDictModel();
    //列表数据源
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false)
    //分页参数
    const initPgCfg = { pageSize: 15, current: 1, pageNum: 1 }
    const [pgCfg, setPgCfg] = useState(initPgCfg);
    //查询条件
    const [searchParam, setSearchParam] = useState({});
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [uploading, setUploading] = useState({ spinning: false, tip: "加速上传中..." });
    const [saveBtnLoading, setSaveBtnLoading] = useState(false); //  保存按钮

    //所有列表查询
    //列表查询
    const loadData = async (page, searchValue = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            shopId: searchValue.shopId ?? shopId,
            shopName: searchValue.shopName ?? shopName,
            shopCode,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? initPgCfg.pageSize,
            pageNum: page?.pageNum ?? pgCfg.current ?? initPgCfg.current,
        }
        let { retData } = await customerService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }
    //设置搜索value
    const updateSearchParam = (updateParam) => {
        setSearchParam({
            ...searchParam,
            ...updateParam
        })
    }
    //重置搜索参数
    const resetSearchParam = async () => {
        await setSearchParam({});
        await setSelectedRowKeys([]);
        await loadData(initPgCfg, {});
    }
    /**
     * 表单详情
     */

    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState({ enable: true });
    //查看表单缓存
    const [lookFormVal, setLookFormVal] = useState({});

    //表单新增修改
    const updateAddFormVal = (val) => {
        val ? setAddFormVal({
            ...addFormVal,
            ...val
        }) : setAddFormVal({ enable: true });
    }
    //表单新增修改
    const updateEditFormVal = (val) => {
        val ? setEditFormVal({
            ...editFormVal,
            ...val
        }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getCustomerOne = async (id, pattern) => {
        let { retData } = await customerService.one(id);
        if (retData && pattern === "edit") {
            setEditFormVal(retData);
        } else if (retData && pattern === "look") {
            setLookFormVal(retData);
        }
    }

    //表单新增 Api
    const insertCustomer = useLockFn(async (data) => {
        setSaveBtnLoading(true)
        let { isTransfer, ...val } = data;
        let params = {
            ...val,
            shopCode,
            shopName,
            shopId,
            orgCode,
            orgName,
            sourceApp,
            branch,
            createUser: getUserInfo() ? getUserInfo().nickname : "未获取到",
            categoryName: getTreeNodeName(data.categoryCode),
            enable: data.enable ? 1 : 0,
        }

        let { retData } = await customerService.insert(params);
        if (isTransfer) {
            await supplierService.insert(params);
        }
        retData ? message.success("客户新增成功") : message.error("客户新增失败");
        setSaveBtnLoading(false)
        return retData;
    })

    //表单编辑 Api
    const editCustomer = useLockFn(async (data) => {
        setSaveBtnLoading(true)
        let params = {
            ...data,
            shopCode,
            shopName,
            shopId,
            orgCode,
            orgName,
            sourceApp,
            branch,
            createUser: getUserInfo() ? getUserInfo().nickname : "未获取到",
            typeName: getTreeNodeName(data.typeCode),
            categoryName: getTreeNodeName(data.categoryCode),
            enable: data.enable ? 1 : 0,

        }
        let { retData } = await customerService.update(params);
        retData ? message.success("客户编辑成功") : message.error("客户编辑失败");
        setSaveBtnLoading(true)
        return retData;
    })
    //客户状态
    const onDisabled = async (id, checked) => {
        let { retData } = await customerService.disable({ id, enable: checked ? 1 : 0 })
        retData ?
            loadData() && message.success("客户编辑成功") : message.error("客户编辑失败");
        return retData;
    }
    //导入
    const importCustomer = async (file) => {
        let { retData } = await customerService.import(file);
        retData ?
            loadData() && message.success("导入成功") : message.error("导入失败");
        return retData;
    }

    //导出
    const exportCustomer = async (searchValue = searchParam) => {
        const searchParams = {
            ...searchValue,
            shopId: searchValue.shopId ?? shopId,
            id: selectedRowKeys.join(),
        }
        let result = await customerService.export(searchParams);
        convertRes2Blob(result)
    }


    //下载模板
    const downloadTpl = async () => {
        let result = await customerService.downloadTpl();
        convertRes2Blob(result)
    }

    //同步
    const sync = async (params = {}) => {
        setUploading({ spinning: true, tip: "正在同步中..." })
        try {
            let result = await customerService.sync({
                ...params,
                shopId,
                shopName,
                "sourceApp": "ci"
            });
            loadData()
            setUploading({ spinning: false })
            message.success("同步成功")
        } catch (err) { setUploading({ spinning: false }) }
    }

    return {
        /***field***/
        searchParam, organType,
        dataSource,
        selectedRowKeys,
        editFormVal,
        addFormVal,
        lookFormVal,
        pgCfg,
        loading,
        /***method***/
        updateAddFormVal,
        updateEditFormVal,
        insertCustomer,
        editCustomer,
        setLoading,
        setPgCfg,
        getCustomerOne,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        importCustomer,
        exportCustomer,
        downloadTpl,
        setEditFormVal,
        setAddFormVal,
        onDisabled,
        setLookFormVal, sync,
        uploading, setUploading, saveBtnLoading, setSaveBtnLoading
    }
});